// extracted by mini-css-extract-plugin
export default {"empty":"CustomerAssets_empty__coag-"};